module.exports = __webpack_public_path__ + "img/上新ico.cfaee446.png";